var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{attrs:{"src":require('@/assets/Presentation.png'),"fluid":"","alt":"Responsive image"}}),_c('p')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }